// extracted by mini-css-extract-plugin
export default {"tableContainer":"PaymentsTabs_tableContainer__FLQaG"};